import React, { useEffect, useState } from "react";
import { Drawer, Select, DatePicker, Spin } from "antd";
import axios from "axios";
import PropTypes from "prop-types";
import { BASE_CRM_URL } from "../../../components/config/config";
import Swal from "sweetalert2";
import dayjs from "dayjs";
// import Swal from "sweetalert2";
// import dayjs from "dayjs";

const UpdateProject = ({
  open,
  onClose,
  getProjects,
  onProjectAdded,
  type,
  record,
}) => {
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const userId = userDetails?.staffid;

  const isRelatedLocked = Boolean(type);
  const [formData, setFormData] = useState({});

  const [loading, setLoading] = useState(false);

  const [customerOptions, setCustomerOptions] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  console.log(selectedCustomer, "cccccccccccccccccccccc");

  useEffect(() => {
    if (!open || !record) return;

    console.log("Edit Project Record:", record);

    setFormData({
      id: record.id,
      name: record.name || "",
      description: record.description || "",
      start_date: record.start_date ? dayjs(record.start_date) : null,
      deadline: record.deadline ? dayjs(record.deadline) : null,
      status: record.status ?? 1,
    });

    // Customer
    setSelectedCustomer(
      record.clientid ?? record.customer_id ?? record.Clientid ?? null,
    );

    // Staff
    const staffIds = Array.isArray(record.staff)
      ? record.staff
          .map((staff) => staff.staff_id ?? staff.staffid)
          .filter(Boolean)
      : Array.isArray(record.staff_id)
        ? record.staff_id
        : [];

    setSelectedStaff(staffIds);
  }, [open, record]);

  const getCustomers = async () => {
    try {
      const response = await fetch(`${BASE_CRM_URL}customers/GetCustomers`);
      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.customerId,
          label: item.company,
        }));

        setCustomerOptions(options);
      }
    } catch (error) {
      console.error("Error fetching related types:", error);
    }
  };

  const [staffData, setStaffData] = useState([]);
  const [staffLoading, setStaffLoading] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState(null);

  const getStaffDropDown = async () => {
    setStaffLoading(true);

    try {
      const response = await axios.get(`${BASE_CRM_URL}staff/GetStaffDropdown`);

      if (response.data?.Status) {
        const data = response.data.ResultData || [];

        const options = data.map((staff) => ({
          value: staff.staffid,
          label: `${staff.firstname} ${staff.lastname}`,
        }));

        setStaffData(options);
      }
    } catch (error) {
      console.error("Leads API Error:", error);
    } finally {
      setStaffLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      getCustomers();
      getStaffDropDown();
    }
  }, [open]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name?.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Project Name Required",
        text: "Please enter project name",
      });
      return;
    }

    if (!selectedCustomer) {
      Swal.fire({
        icon: "warning",
        title: "Customer Required",
        text: "Please select a customer",
      });
      return;
    }

    if (!formData.start_date) {
      Swal.fire({
        icon: "warning",
        title: "Start Date Required",
        text: "Please select start date",
      });
      return;
    }

    if (!formData.deadline) {
      Swal.fire({
        icon: "warning",
        title: "End Date Required",
        text: "Please select end date",
      });
      return;
    }

    if (formData.deadline.isBefore(formData.start_date, "day")) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Date",
        text: "End date cannot be before start date",
      });
      return;
    }

    try {
      setLoading(true);

      const payload = {
        // Project ID
        id: record?.id,

        // Editable fields
        name: formData.name.trim(),

        description: formData.description || "",

        status: formData.status ?? record?.status ?? 1,

        clientid: selectedCustomer,

        start_date: formData.start_date.format("YYYY-MM-DD"),

        deadline: formData.deadline.format("YYYY-MM-DD"),

        // Static fields
        billing_type: 1,

        project_created: record?.project_created
          ? dayjs(record.project_created).format("YYYY-MM-DD")
          : dayjs().format("YYYY-MM-DD"),

        progress: record?.progress ?? 0,

        progress_from_tasks: record?.progress_from_tasks ?? 0,

        project_cost: record?.project_cost ?? 0,

        project_rate_per_hour: record?.project_rate_per_hour ?? 0,

        estimated_hours: record?.estimated_hours ?? 0,

        addedfrom: record?.addedfrom ?? userId,

        // Selected staff IDs
        staff_id: selectedStaff || [],
      };

      console.log("Update Project Payload:", payload);

      const response = await axios.post(
        `${BASE_CRM_URL}project/UpdateProject`,
        payload,
      );

      if (response.data?.Status) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: "Project updated successfully",
          confirmButtonText: "OK",
        });

       

        // Refresh table
        if (onProjectAdded) {
          await onProjectAdded();
        } else if (getProjects) {
          await getProjects();
        }

         setLoading(false);
        // Close drawer
        onClose?.();

        // Reset
        setFormData({});
        setSelectedCustomer(null);
        setSelectedStaff([]);
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: response.data?.Message || "Failed to update project",
        });
      }
    } catch (error) {
      console.error("Update Project Error:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data?.Message ||
          "Something went wrong while updating project",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {loading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <Drawer
        title="Update Project"
        placement="right"
        width={600}
        open={open}
        onClose={onClose}
        destroyOnClose
        maskClosable={!loading}
        closable={false}
        extra={
          <div className="d-flex align-items-center gap-2">
            {/* Close */}
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
              style={{
                width: "35px",
                height: "35px",
                backgroundColor: "#e40d22",
                color: "#fff",
                border: "none",
              }}
              title="Close"
            >
              <i className="fa fa-times" />
            </button>

            {/* Save */}
            <button
              type="button"
              onClick={handleSubmit}
              disabled={loading}
              className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
              style={{
                width: "35px",
                height: "35px",
                backgroundColor: "#07f083",
                color: "#fff",
                border: "none",
              }}
              title="Save"
            >
              {loading ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                <i className="fa fa-check" />
              )}
            </button>
          </div>
        }
      >
        <form id="projectForm" onSubmit={handleSubmit}>
          <div className="row">
            {/* Project Name */}
            <div className="col-12 mb-3">
              <label className="form-label">
                Project Name <span className="text-danger">*</span>
              </label>

              <input
                type="text"
                className="form-control"
                placeholder="Enter project name"
                value={formData.name}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    name: e.target.value,
                  })
                }
              />
            </div>

            {/* Start Date */}
            <div className="col-md-6 mb-3">
              <label className="form-label">
                Start Date <span className="text-danger">*</span>
              </label>

              <DatePicker
                className="w-100"
                format="DD-MM-YYYY"
                placeholder="Select start date"
                value={formData.start_date}
                onChange={(date) =>
                  setFormData({
                    ...formData,
                    start_date: date,
                  })
                }
              />
            </div>

            {/* Deadline */}
            <div className="col-md-6 mb-3">
              <label className="form-label">
                End Date <span className="text-danger">*</span>
              </label>

              <DatePicker
                className="w-100"
                format="DD-MM-YYYY"
                placeholder="Select deadline"
                value={formData.deadline}
                disabledDate={(current) => {
                  const startDate = formData.start_date;

                  return (
                    startDate && current && current.isBefore(startDate, "day")
                  );
                }}
                onChange={(date) =>
                  setFormData({
                    ...formData,
                    deadline: date,
                  })
                }
              />
            </div>
            {/* Customer */}
            <div className="col-6 mb-3">
              <label className="form-label">
                Customer <span className="text-danger">*</span>
              </label>

              <Select
                showSearch
                placeholder="Select Customer"
                optionFilterProp="label"
                className="w-100"
                style={{ height: 38 }}
                options={customerOptions}
                value={selectedCustomer}
                disabled={isRelatedLocked}
                onChange={(value) => {
                  console.log(value, "valuuuuuuuuuuuuuuuuuuuuu");
                  setSelectedCustomer(value);
                }}
              />
            </div>

            {/* Status */}
            {/* <div className="col-md-6 mb-3">
            <label className="form-label">Status</label>

            <Select
              className="w-100"
              placeholder="Select status"
              value={formData.status}
              style={{height:38}}
              onChange={(value) =>
                setFormData({
                  ...formData,
                  status: value,
                })
              }
              options={[
                {
                  value: 1,
                  label: "Not Started",
                },
                {
                  value: 2,
                  label: "In Progress",
                },
                {
                  value: 3,
                  label: "Finished",
                },
                {
                  value: 4,
                  label: "Cancelled",
                },
              ]}
            />
          </div> */}

            {/* Members */}
            <div className="col-6 mb-3">
              <label className="form-label">Project Members</label>

              <Select
                mode="multiple"
                className="w-100"
                placeholder="Select project members"
                style={{ height: 38 }}
                showSearch
                allowClear
                loading={staffLoading}
                optionFilterProp="label"
                options={staffData}
                value={selectedStaff}
                onChange={(value) => {
                  console.log(value, "valuuuuuuuuuuuuuuuuuuuuu");
                  setSelectedStaff(value);
                }}
              />
            </div>
            <div className="col-12 mb-3">
              <label className="form-label">Description</label>

              <textarea
                className="form-control"
                rows={3}
                placeholder="Enter project description"
                value={formData.description}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    description: e.target.value,
                  })
                }
              />
            </div>
          </div>
        </form>
      </Drawer>
    </div>
  );
};
UpdateProject.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,

  getProjects: PropTypes.func.isRequired,
  type: PropTypes.string,
  onProjectAdded: PropTypes.func.isRequired,
  record: PropTypes.object,
};
export default UpdateProject;
